import {createI18n} from 'vue-i18n'
import en from './locales/en.js'
import pl from './locales/pl.js'
import uk from './locales/uk.js'
import cz from './locales/cz.js'

const savedLang = localStorage.getItem('lang') || 'uk';

export default createI18n({
    legacy: false,
    globalInjection: true,
    locale: savedLang,
    fallbackLocale: 'uk',
    messages: {
        en,
        pl,
        uk,
        cz
    }
})
